export default {
  getters: {
    getById: state => id => {
      return state.data[id] ? state.data[id] : null;
    },
    getNameById: state => id => {
      return state.data[id] ? state.data[id].name : null;
    },
  },
};
